import { AppPages, navigate } from '../../common/routing/app-navigator';
import { loadApplications } from '../actions/applications-actions';
import { loadFilters } from '../actions/applications-filters-actions';
import { FilterApplicationsType } from '../applications-types';
import ApplicationsFiltersStore from './applications-filters-store';

export const setTotalAppsFilters = (totalFilters: number) => {
  ApplicationsFiltersStore.totalFilters = totalFilters;
};

export const setSliderRiskScore = (range: number[]) => {
  ApplicationsFiltersStore.sliderRiskScore = range;
};

export const setSliderBuisnessPriority = (range: number[]) => {
  ApplicationsFiltersStore.sliderBuisnessPriority = range;
};

export const setMaxRiskScore = (max: number) => {
  ApplicationsFiltersStore.maxRiskScore = max;
};

export const setMaxBuisnessPriority = (max: number) => {
  ApplicationsFiltersStore.maxBuisnessPriority = max;
};

export const clearFilters = () => {
  ApplicationsFiltersStore.filterBy = {};
  ApplicationsFiltersStore.numberOfFilters = 0;
  ApplicationsFiltersStore.sliderRiskScore = [
    0,
    ApplicationsFiltersStore.maxRiskScore,
  ];
  ApplicationsFiltersStore.sliderBuisnessPriority = [
    0,
    ApplicationsFiltersStore.maxBuisnessPriority,
  ];
  navigate(AppPages.Applications);
  loadApplications({ update: true, cache: false });
  loadFilters();
};

export const setStoreApplicationsFilters = (
  applicationsFilters: FilterApplicationsType,
) => {
  ApplicationsFiltersStore.appsFiltersType = applicationsFilters;
};

export const setStoreApplicationsFiltersTypeSearch = (
  appsFiltersTypeSearch: FilterApplicationsType,
): void => {
  ApplicationsFiltersStore.appsFiltersTypeSearch = appsFiltersTypeSearch;
};

export const setSearchValues = (type: string, searchValue: string) => {
  ApplicationsFiltersStore.searchValues[type] = searchValue;
};
